import { Suspense, lazy, useEffect } from 'react';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

//import Login from './Login';
import Login from './pages/Login';
import Dashboard from "./dashboard/Dashboard";

import { Routes, Route, BrowserRouter, Navigate, useLocation } from "react-router-dom";
import './lib/firebase/firebase';
import Loader from './components/Loader';
//import Tutorial from './pages/Tutorial';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MARKETING_SITE_URL } from './lib/downloads';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const Analisar = lazy(() => import('./analisar/Analisar'));
const Motion = lazy(() => import('./motion/Motion'));
const Assinar = lazy(() => import('./pages/assinatura/Assinar'));
const RedeemBonus = lazy(() => import('./pages/RedeemBonus'));
const Updates = lazy(() => import('./pages/Updates'));
const Support = lazy(() => import('./pages/Support'));
const Account = lazy(() => import('./pages/Account'));

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return <Loader vh={80} />;
}

function RequireLegacyAccess({ children }) {
  const { user, loading, legacyWebAccess } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader vh={80} />;
  }

  if (!user) {
    const redirect = encodeURIComponent(`${location.pathname.replace(/^\/+/, '')}${location.search}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (!legacyWebAccess) {
    return <Navigate to="/minha-conta?legacy=disabled" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/analisar/:analiseUid"
              element={
                <RequireLegacyAccess>
                  <Suspense fallback={<Loader vh={80} />}>
                    <Analisar />
                  </Suspense>
                </RequireLegacyAccess>
              }
            />
            <Route
              path="/motion/:analiseUid"
              element={
                <RequireLegacyAccess>
                  <Suspense fallback={<Loader vh={80} />}>
                    <Motion />
                  </Suspense>
                </RequireLegacyAccess>
              }
            />
            <Route
              path="/dashboard"
              element={
                <RequireLegacyAccess>
                  <Dashboard />
                </RequireLegacyAccess>
              }
            />
            <Route path="/precos" element={<Navigate to="/login" replace />} />
            <Route path="/criar-conta" element={<Navigate to="/login" replace />} />
            <Route
              path="/assinar"
              element={
                <Suspense fallback={<Loader vh={80} />}>
                  <Assinar />
                </Suspense>
              }
            />
            <Route
              path="/redeemBonus/:bonusUid"
              element={
                <Suspense fallback={<Loader vh={80} />}>
                  <RedeemBonus />
                </Suspense>
              }
            />
            <Route
              path="/updates"
              element={
                <Suspense fallback={<Loader vh={80} />}>
                  <Updates />
                </Suspense>
              }
            />
            <Route
              path="/suporte"
              element={
                <Suspense fallback={<Loader vh={80} />}>
                  <Support />
                </Suspense>
              }
            />
            <Route
              path="/download"
              element={<ExternalRedirect to={MARKETING_SITE_URL} />}
            />
            <Route
              path="/minha-conta"
              element={
                <Suspense fallback={<Loader vh={80} />}>
                  <Account />
                </Suspense>
              }
            />
            <Route
              path="/documentacao/*"
              element={<Navigate to="/login" replace />}
            />
            <Route
              path="/tutorial/*"
              element={<Navigate to="/login" replace />}
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
